import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { APP_NAME } from "../../utils/constants";

export const useDynamicPageTitle = (menuItems: any[], appName = APP_NAME) => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Find the current menu item matching the pathname
    const current = menuItems.find(
      (item) => item.path === pathname || item.to === pathname,
    );

    if (current?.label) {
      // Use label if available
      document.title = `${current.label} | ${appName}`;
    } else if (current?.path) {
      // Get title from path
      const pathWithoutSlash = current.path.replace(/^\/+/, "");
      const title =
        pathWithoutSlash.charAt(0).toUpperCase() + pathWithoutSlash.slice(1);
      document.title = `${title} | ${appName}`;
    } else {
      // Default
      document.title = appName;
    }
  }, [pathname, menuItems, appName]);
};
